import { useEffect, useState } from 'react';
import dynamicfunction from '../../utils/dynamicfunction';
import { useDispatch, useSelector } from 'react-redux';
import { getContentKeyAccToLang } from '../../utils/utils';
import { useLocation, useNavigate } from 'react-router';
import {
  buyOrderAccept,
  buyOrderCancel,
  getBuyOrder,
  getSellOrder,
  getSingleBuyOrder,
  getSingleSellOrder,
  sellOrderAccept,
  sellOrderCancel,
} from '../../store/actions/fund-action';

export default () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const pathname = useLocation()

  const { TextWeight, isArabic } = dynamicfunction();

  const { fundsContent } = useSelector((state) => state.content);
  const { user } = useSelector((state) => state.common);
  const {
    buy_order_data,
    buy_order_loading,
    sell_order_data,
    sell_order_loading,
    single_Buy_order_data,
    single_Buy_order_loading,
    single_sell_order_data,
    single_sell_order_loading,
    order_accept_loading,
    order_cancel_loading,
  } = useSelector((state) => state.fund);

  const [buyOrderReviewModal, setBuyOrderReviewModal] = useState(false);
  const [sellOrderReviewModal, setSellOrderReviewModal] = useState(false);
  const [buyView, setBuyView] = useState(null);
  const [sellView, setSellView] = useState(null);

  useEffect(() => {
    getData();
  }, []);

  const getData = async () => {
    await dispatch(getBuyOrder(user?.investorTypeId));
    await dispatch(getSellOrder(user?.investorTypeId));
  }


  useEffect(() => {
    if (process.env.REACT_APP_ENVIRONMENT === 'PRODUCTION') {
      navigate(-1)
    }
  }, [])

  const buyOrderToogleReviewModal = () =>
    setBuyOrderReviewModal(!buyOrderReviewModal);

  const sellOrderToogleReviewModal = () =>
    setSellOrderReviewModal(!sellOrderReviewModal);

  const getContentKey = (key) => {
    return getContentKeyAccToLang(
      fundsContent?.web_funds_order_status?.data?.attributes,
      key,
      isArabic
    );
  };

  const handleAcceptBuyOrder = () => {
    dispatch(
      buyOrderAccept(buyView.orderNo, () => {
        setBuyOrderReviewModal(false);
        dispatch(getBuyOrder(user?.investorTypeId));
      })
    );
  };

  const handleCancelBuyOrder = () => {
    const api_data = {
      id: buyView.orderNo,
      data: {
        remarks: 'Cancel',
      },
    };

    dispatch(
      buyOrderCancel(api_data, () => {
        setBuyOrderReviewModal(false);
        dispatch(getBuyOrder(user?.investorTypeId));
      })
    );
  };

  const handleAcceptSellOrder = () => {
    dispatch(
      sellOrderAccept(sellView.orderNo, () => {
        setSellOrderReviewModal(false);
        dispatch(getSellOrder(user?.investorTypeId));
      })
    );
  };

  const handleCancelSellOrder = () => {
    const api_data = {
      id: sellView.orderNo,
      data: {
        remarks: 'Cancel',
      },
    };

    dispatch(
      sellOrderCancel(api_data, () => {
        setSellOrderReviewModal(false);
        dispatch(getSellOrder(user?.investorTypeId));
      })
    );
  };

  return {
    isArabic,
    buy_order_data,
    buy_order_loading,
    sell_order_data,
    sell_order_loading,
    single_Buy_order_data,
    single_Buy_order_loading,
    single_sell_order_data,
    single_sell_order_loading,
    TextWeight,
    getContentKey,
    buyOrderReviewModal,
    setBuyOrderReviewModal,
    sellOrderReviewModal,
    setSellOrderReviewModal,
    sellOrderToogleReviewModal,
    buyOrderToogleReviewModal,
    sellView,
    setSellView,
    buyView,
    setBuyView,
    navigate,
    handleAcceptBuyOrder,
    handleCancelBuyOrder,
    handleAcceptSellOrder,
    handleCancelSellOrder,
    dispatch,
    getSingleBuyOrder,
    user,
    getSingleSellOrder,
    order_accept_loading,
    order_cancel_loading,
  };
};
